import { isTrainFeatureEnabled } from '@juvare/credentialing/ui/utils';
export function validateOccupationsCriteria(occupationGroup, occupations, allOccupations) {
    const hasOccupationGroups = !!(occupationGroup === null || occupationGroup === void 0 ? void 0 : occupationGroup.length);
    const hasOccupations = !!(occupations === null || occupations === void 0 ? void 0 : occupations.length);
    return {
        hasOccupationGroups,
        hasOccupations,
        hasGroupNoOccupations: hasOccupationGroups && !hasOccupations && !allOccupations,
        hasOccupationsNoGroup: !hasOccupationGroups && hasOccupations,
        hasGroupAllOccupations: allOccupations && hasOccupationGroups,
    };
}
export function areQualificationsCriteriaMet(handler, userState) {
    const criteriaFields = ['skillIds', 'trainingIds', 'languageIds'];
    if (isTrainFeatureEnabled(userState)) {
        criteriaFields.push('trainCourseIds');
    }
    return criteriaFields.some((field) => {
        var _a;
        const data = (_a = handler.up().down(field)) === null || _a === void 0 ? void 0 : _a.getData();
        return !!(data === null || data === void 0 ? void 0 : data.length);
    });
}
export function validateQualificationsCriteria(handler, userState) {
    var _a, _b, _c;
    const occupationGroupData = (_a = handler.up().down('groupIds')) === null || _a === void 0 ? void 0 : _a.getData();
    const occupationData = (_b = handler.up().down('occupationIds')) === null || _b === void 0 ? void 0 : _b.getData();
    const allOccupations = (_c = handler.up().down('allOccupations')) === null || _c === void 0 ? void 0 : _c.getData();
    const qualificationsCriteriaAreMet = areQualificationsCriteriaMet(handler, userState);
    const { hasOccupationGroups, hasOccupationsNoGroup, hasGroupNoOccupations, hasGroupAllOccupations } = validateOccupationsCriteria(occupationGroupData, occupationData, allOccupations);
    if (hasOccupationsNoGroup || hasGroupNoOccupations || hasGroupAllOccupations) {
        return undefined;
    }
    if (!qualificationsCriteriaAreMet && !hasOccupationGroups) {
        return 'At least one mission position criteria is required';
    }
    return undefined;
}
